<template>
  <div>
    <v-row justify="center">
      <v-col class="col-auto text-subtitle-1 text-center">
        <div v-if="singlePrintID && singlePerson">
          {{ singlePerson.姓名 }} ({{ singlePerson.身分證字號 }})
        </div>
        <template v-if="!singlePrintID">
          <div>本場總共預約人數：{{ list.length }}</div>
          <div>
            成人健檢人數：{{ list.filter((o) => o.篩檢項目.成健).length }}
          </div>
          <div>
            BC肝檢查人數：{{ list.filter((o) => o.篩檢項目.BC肝).length }}
          </div>
          <div>
            子宮抹片檢查人數：{{ list.filter((o) => o.篩檢項目.子抹).length }}
          </div>
          <div>
            糞便潛血檢查人數：{{ list.filter((o) => o.篩檢項目.大腸).length }}
          </div>
          <div>
            口腔黏膜檢查人數：{{ list.filter((o) => o.篩檢項目.口腔).length }}
          </div>
          <div>
            乳房X光攝影人數：{{ list.filter((o) => o.篩檢項目.乳攝).length }}
          </div>
          <div>
            胃篩檢查人數：{{ list.filter((o) => o.篩檢項目.胃篩).length }}
          </div>
          <div>
            HPV檢查人數：{{ list.filter((o) => o.篩檢項目.HPV).length }}
          </div>
          <div>
            ICOPE檢查人數：{{ list.filter((o) => o.篩檢項目.ICOPE).length }}
          </div>
        </template>

        <div class="pl-8 mb-4">
          <v-checkbox
            v-if="!isHospital"
            v-model="checkbox.成健封面"
            label="成健封面"
            dense
            hide-details
          ></v-checkbox>
          <v-checkbox
            v-if="!isHospital"
            v-model="checkbox.外部問卷"
            label="外部問卷"
            dense
            hide-details
          ></v-checkbox>
          <v-checkbox
            v-model="checkbox.癌症篩檢表"
            label="癌症篩檢表"
            dense
            hide-details
          ></v-checkbox>
          <v-btn
            v-if="checkbox.癌症篩檢表"
            small
            text
            color="primary"
            class="mt-1 px-0"
            @click="cancerExpanded = !cancerExpanded"
          >
            {{ cancerExpanded ? "收合癌篩項目" : "展開癌篩項目" }}
          </v-btn>
          <v-expand-transition>
            <div v-if="checkbox.癌症篩檢表 && cancerExpanded" class="pl-4">
              <v-checkbox
                v-for="item in cancerItems"
                :key="item.value"
                v-model="checkbox.癌症篩檢項目[item.value]"
                :label="item.text"
                dense
                hide-details
              ></v-checkbox>
            </div>
          </v-expand-transition>
        </div>
        <div v-if="!singlePrintID">
          列印
          <v-text-field
            v-model="startNum"
            dense
            outlined
            hide-details
            class="d-inline-block"
            style="width: 50px"
          ></v-text-field>
          號 -
          <v-text-field
            v-model="endNum"
            dense
            outlined
            hide-details
            class="d-inline-block"
            style="width: 50px"
          ></v-text-field>
          號
        </div>
        <div>
          列印頁數共
          {{ printPageCount }}
          頁
        </div>
        <div class="text-center mt-4">
          <v-btn
            ref="btnPrint"
            v-print="printObj"
            color="primary"
            class="d-none"
          >
            第一階段民眾資料列印
          </v-btn>
          <v-btn color="primary" @click="download">{{
            singlePrintID ? "單筆列印" : "第一階段民眾資料列印"
          }}</v-btn>
        </div>
      </v-col>
    </v-row>
    <div class="preLoad">
      <img src="/print/口篩.jpg" alt="" />
      <img src="/print/子抹.jpg" alt="" />
      <img src="/print/乳攝.jpg" alt="" />
      <img src="/print/乳攝_2.jpg" alt="" />
      <img src="/print/腸篩.jpg" alt="" />
      <img src="/print/胃篩.jpg" alt="" />
      <img src="/print/HPV.jpg" alt="" />
      <img src="/print/BC肝.jpg" alt="" />
      <img src="/print/問卷封面.jpg" alt="" />
    </div>
    <section id="printBlock" v-if="DEBUG || printReady">
      <!-- <template v-for="n in 100"> -->
      <div
        class="onlyPrint"
        :style="{ display: DEBUG ? 'block' : '' }"
        v-for="person of filterList"
        v-if="person && section"
      >
        <Page
          v-if="DEBUG_ITEM.成健封面 || (問卷顯示或整合 && checkbox.成健封面)"
        >
          <PageTitle :person="person"></PageTitle>
        </Page>
        <Page
          v-if="DEBUG_ITEM.問卷封面 || (問卷顯示或整合 && checkbox.成健封面)"
          :config="Items.問卷封面(person, section)"
        >
          <CheckinNum :person="person" :withTime="true" />
        </Page>
        <Page
          v-if="
            DEBUG_ITEM.外部問卷 ||
            (問卷顯示或整合 && person.report[0].外部問卷 && checkbox.外部問卷)
          "
        >
          <CheckinNum :person="person" />
          <B1 :q="person.report[0].外部問卷"></B1>
        </Page>
        <Page
          v-if="
            DEBUG_ITEM.外部問卷 ||
            (問卷顯示或整合 && person.report[0].外部問卷 && checkbox.外部問卷)
          "
        >
          <CheckinNum :person="person" />
          <B2 :q="person.report[0].外部問卷"></B2>
        </Page>
        <Page
          v-if="
            DEBUG_ITEM.外部問卷 ||
            (問卷顯示或整合 && person.report[0].外部問卷 && checkbox.外部問卷)
          "
        >
          <CheckinNum :person="person" />
          <B3
            :q="{
              ...person.report[0].外部問卷,
              '(女性填答)當您用力咳嗽時，是否有漏尿情形?': (person.問卷 || {})
                .用力咳嗽是否漏尿,
            }"
          ></B3>
        </Page>
        <Page
          v-if="
            DEBUG_ITEM.外部問卷 ||
            (問卷顯示或整合 && person.report[0].外部問卷 && checkbox.外部問卷)
          "
        >
          <CheckinNum :person="person" />
          <B4 :q="person.report[0].外部問卷" :person="person"></B4>
        </Page>

        <Page
          v-if="
            DEBUG_ITEM.外部問卷 ||
            (問卷顯示或整合 && person.report[0].外部問卷 && checkbox.外部問卷)
          "
        >
          <CheckinNum :person="person" />
          <B5 :q="person.report[0].外部問卷" :person="person"></B5>
        </Page>
        <Page
          v-if="
            DEBUG_ITEM.外部問卷 ||
            (問卷顯示或整合 && person.report[0].外部問卷 && checkbox.外部問卷)
          "
        >
          <CheckinNum :person="person" />
          <B6 :q="person.report[0].外部問卷"></B6>
        </Page>
        <Page
          :config="Items.BC肝(person, section)"
          v-if="
            DEBUG_ITEM.BC肝 ||
            (問卷顯示或整合 && person.篩檢項目.BC肝 && cancerPrintEnabled('BC肝'))
          "
        >
          <CheckinNum :person="person" />
        </Page>
        <Page
          v-if="
            DEBUG_ITEM.外部問卷 ||
            (問卷顯示或整合 &&
              person.篩檢項目.BC肝 &&
              cancerPrintEnabled('BC肝') &&
              (checkbox.成健封面 || checkbox.外部問卷))
          "
        >
          <CheckinNum :person="person" />
        </Page>
        <Page
          :config="Items.腸篩(person, section)"
          v-if="
            DEBUG_ITEM.大腸 ||
            (問卷顯示或整合 && person.篩檢項目.大腸 && cancerPrintEnabled('大腸'))
          "
        >
          <CheckinNum :person="person" />
        </Page>
        <Page
          v-if="
            DEBUG_ITEM.外部問卷 ||
            (問卷顯示或整合 &&
              person.篩檢項目.大腸 &&
              cancerPrintEnabled('大腸') &&
              (checkbox.成健封面 || checkbox.外部問卷))
          "
        >
          <CheckinNum :person="person" />
        </Page>
        <Page
          :config="Items.胃篩(person, section)"
          v-if="
            DEBUG_ITEM.胃篩 ||
            (問卷顯示或整合 && person.篩檢項目.胃篩 && cancerPrintEnabled('胃篩'))
          "
        >
          <CheckinNum :person="person" />
        </Page>
        <Page
          :config="Items.胃篩檢驗結果()"
          v-if="
            DEBUG_ITEM.胃篩 ||
            (問卷顯示或整合 && person.篩檢項目.胃篩 && cancerPrintEnabled('胃篩'))
          "
        >
          <CheckinNum :person="person" />
        </Page>
        <Page
          v-if="
            DEBUG_ITEM.外部問卷 ||
            (問卷顯示或整合 &&
              person.篩檢項目.胃篩 &&
              cancerPrintEnabled('胃篩') &&
              (checkbox.成健封面 || checkbox.外部問卷))
          "
        >
          <CheckinNum :person="person" />
        </Page>
        <Page
          :config="Items.HPV(person, section)"
          v-if="
            DEBUG_ITEM.HPV ||
            (問卷顯示或整合 && person.篩檢項目.HPV && cancerPrintEnabled('HPV'))
          "
        >
          <CheckinNum :person="person" />
        </Page>
        <Page
          v-if="
            DEBUG_ITEM.外部問卷 ||
            (問卷顯示或整合 &&
              person.篩檢項目.HPV &&
              cancerPrintEnabled('HPV') &&
              (checkbox.成健封面 || checkbox.外部問卷))
          "
        >
          <CheckinNum :person="person" />
        </Page>
        <Page
          :config="Items.乳攝(person, section)"
          v-if="
            DEBUG_ITEM.乳攝 ||
            (問卷顯示或整合 && person.篩檢項目.乳攝 && cancerPrintEnabled('乳攝'))
          "
        >
          <CheckinNum :person="person" />
        </Page>
        <Page
          :config="Items.乳攝2(person, section)"
          v-if="
            DEBUG_ITEM.乳攜 ||
            (問卷顯示或整合 && person.篩檢項目.乳攜 && cancerPrintEnabled('乳攝'))
          "
        >
          <CheckinNum :person="person" />
        </Page>
        <Page
          :config="Items.子抹(person, section)"
          v-if="
            DEBUG_ITEM.子抹 ||
            (問卷顯示或整合 && person.篩檢項目.子抹 && cancerPrintEnabled('子抹'))
          "
        >
          <CheckinNum :person="person" />
        </Page>
        <Page
          v-if="
            DEBUG_ITEM.外部問卷 ||
            (問卷顯示或整合 &&
              person.篩檢項目.子抹 &&
              cancerPrintEnabled('子抹') &&
              (checkbox.成健封面 || checkbox.外部問卷))
          "
        >
          <CheckinNum :person="person" />
        </Page>
        <Page
          :config="Items.口篩(person, section)"
          v-if="
            DEBUG_ITEM.口篩 ||
            (問卷顯示或整合 && person.篩檢項目.口腔 && cancerPrintEnabled('口腔'))
          "
        >
          <CheckinNum :person="person" />
        </Page>
        <Page
          v-if="
            DEBUG_ITEM.外部問卷 ||
            (問卷顯示或整合 &&
              person.篩檢項目.口腔 &&
              cancerPrintEnabled('口腔') &&
              (checkbox.成健封面 || checkbox.外部問卷))
          "
        >
          <CheckinNum :person="person" />
        </Page>
      </div>
      <!-- </template> -->
    </section>
  </div>
</template>

<script>
import dayjs from "dayjs";
import print from "vue-print-nb";
import Page from "@/components/Print/page";
import Items from "@/libs/printItems";
import PageTitle from "@/components/Print/pageTitle";
import B1 from "./BigQuize/b1.vue";
import B2 from "./BigQuize/b2.vue";
import B3 from "./BigQuize/b3.vue";
import B4 from "./BigQuize/b4.vue";
import B5 from "./BigQuize/b5.vue";
import B6 from "./BigQuize/b6.vue";
import CheckinNum from "./checkinNum.vue";
import util from "@/mixins/util";
import ls from "expired-localstorage";

const DEBUG = false;
const DEBUG_ITEM = {
  成健封面: false,
  問卷封面: false,
  外部問卷: false,
  癌症篩檢表: false,
  BC肝: false,
  大腸: false,
  乳攝: false,
  子抹: false,
  口篩: false,
  HPV: false,
  胃篩: false,
};
const 年度 = dayjs().get("year") - 1911;
export default {
  name: "Print",
  directives: {
    print,
  },
  components: { Page, PageTitle, B1, B2, B3, B4, B5, B6, CheckinNum },
  mixins: [util],
  props: ["list", "selectedSection", "singlePrintID"],
  data: () => ({
    Items,
    printObj: {
      id: "#printBlock",
      extraCss: `/vendor/vuetify/vuetify.min.css`,
    },
    printReady: false,
    startNum: 0,
    endNum: 0,
    section: null,
    cancerExpanded: false,
    cancerItems: [
      { text: "BC肝", value: "BC肝" },
      { text: "大腸", value: "大腸" },
      { text: "胃篩", value: "胃篩" },
      { text: "HPV", value: "HPV" },
      { text: "乳攝", value: "乳攝" },
      { text: "子抹", value: "子抹" },
      { text: "口腔", value: "口腔" },
    ],
    checkbox: {
      成健封面: true,
      外部問卷: true,
      癌症篩檢表: true,
      癌症篩檢項目: {
        BC肝: true,
        大腸: true,
        胃篩: true,
        HPV: true,
        乳攝: true,
        子抹: true,
        口腔: true,
      },
    },
    DEBUG,
    DEBUG_ITEM,
  }),
  computed: {
    singlePerson() {
      // console.log(this.singlePrintID);
      // console.log(this.filterList);
      return this.filterList[0];
    },
    問卷顯示或整合() {
      return this.section && (this.section.整合式篩檢 || this.section.顯示問卷);
    },
    filterList() {
      return this.list.filter(
        (person) =>
          parseInt(person.報到號碼) >= this.startNum &&
          parseInt(person.報到號碼) <= this.endNum,
      );
    },
    printPageCount() {
      if (!this.問卷顯示或整合) return 0;
      const hasCoverOrQuestionnaire = this.checkbox.成健封面 || this.checkbox.外部問卷;
      let count = 0;
      count +=
        this.filterList.filter((o) => !o.report[0].外部問卷).length *
        2 *
        (this.checkbox.成健封面 ? 1 : 0);
      count +=
        this.filterList.filter((o) => !!o.report[0].外部問卷).length *
        2 *
        (this.checkbox.成健封面 ? 1 : 0);
      count +=
        this.filterList.filter((o) => !!o.report[0].外部問卷).length *
        6 *
        (this.checkbox.外部問卷 ? 1 : 0);
      count += this.cancerPageCount("BC肝", "BC肝", 1, hasCoverOrQuestionnaire);
      count += this.cancerPageCount("子抹", "子抹", 1, hasCoverOrQuestionnaire);
      count += this.cancerPageCount("大腸", "大腸", 1, hasCoverOrQuestionnaire);
      count += this.cancerPageCount("口腔", "口腔", 1, hasCoverOrQuestionnaire);
      count += this.cancerPageCount("乳攝", "乳攝", 1, hasCoverOrQuestionnaire);
      count += this.cancerPageCount("胃篩", "胃篩", 2, hasCoverOrQuestionnaire);
      count += this.cancerPageCount("HPV", "HPV", 1, hasCoverOrQuestionnaire);
      return count;
    },
  },
  async created() {
    let res = await this.axios.get("/dashboard/section", {
      params: this.selectedSection,
    });
    await this.axios.post(
      "/dashboard/section/prepareChecking",
      this.selectedSection,
    );
    this.section = res.data[0];
    this.$emit("loadList");
    this.startNum = this.singlePrintID || 1;
    this.endNum = this.singlePrintID || this.list.length;
    if (this.singlePrintID) {
      this.checkbox = ls.get("printCheckbox") || this.checkbox;
    }
    this.normalizeCancerCheckboxes();
    if (this.isHospital) {
      this.checkbox.成健封面 = false;
      this.checkbox.外部問卷 = false;
    }
  },
  methods: {
    cancerPrintEnabled(item) {
      return this.checkbox.癌症篩檢表 && this.checkbox.癌症篩檢項目?.[item];
    },
    cancerPageCount(item, checkItem, formPages, hasCoverOrQuestionnaire) {
      if (!this.cancerPrintEnabled(item)) return 0;
      const blankPage = hasCoverOrQuestionnaire ? 1 : 0;
      return (
        this.filterList.filter((o) => o.篩檢項目[checkItem]).length *
        (formPages + blankPage)
      );
    },
    normalizeCancerCheckboxes() {
      const selected = this.checkbox.癌症篩檢項目 || {};
      this.$set(this.checkbox, "癌症篩檢項目", {});
      this.cancerItems.forEach((item) => {
        this.$set(
          this.checkbox.癌症篩檢項目,
          item.value,
          selected[item.value] !== false,
        );
      });
    },
    async download() {
      this.printReady = true;
      this.$nextTick(() => {
        this.$refs.btnPrint.$el.click();
        if (this.singlePrintID) {
          ls.set("printCheckbox", this.checkbox);
          this.$emit("close");
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen {
  .onlyPrint {
    margin: 0;
    padding: 0;
    // display: block;
    display: none;
  }
}
@media print {
  .noPrint {
    display: none;
  }
  .onlyPrint {
    display: block;
  }
}

#printBlock {
  position: relative;
  margin: 0;
  padding: 0;
  // color: red;
}
.preLoad {
  width: 0;
  height: 0;
  overflow: hidden;
}
</style>
